import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Nick
 * id 0934FB0D-8585-4064-989F-054E52D16FDB
 * name cards-diamond
 * version: 2.3.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cards-diamond.svg
 * tags
 * - Gaming / RPG 
 * - Transportation + Road 
 */
export const CardsDiamondIcon = createSvgIcon(<><path d="M19,12L12,22L5,12L12,2" /></>, 'CardsDiamondIcon');
export default CardsDiamondIcon